module.exports = __webpack_public_path__ + "img/icon-delete-2.487087b7.svg";